import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ExcelExportService {

    public isExportAvailable = true;
    public onExportPressed = new Subject();
    public currentTableData: Array<any>;

    startExport() {
        this.onExportPressed.next();
    }
}
